import React from 'react';

import Pricing from '../../components/Pricing';
import LandingSectionHeader from './LandingSectionHeader';

function LandingPricing() {
  return <>
    <LandingSectionHeader eyebrow="Simple, Worry-free, Flat Pricing With No Surprises" title="Start Today and Test for Free" description="No card required. Upgrade to Pro for unlimited REST or Business for unlimited REST, WebSockets, and MCP Server access. 30-day money-back guarantee." />
    <Pricing />
  </>;
}

export default LandingPricing;
